'use strict';

function removeListener() {
    // This line is needed for NVDA screen reader that makes hidden clicks when you press enter
    if (event.detail === 0) {
        return;
    }

    $('body').removeClass('keyboard-focus');
    window.removeEventListener('mousedown', removeListener);
    window.addEventListener('keydown', addListener); // eslint-disable-line no-use-before-define
}

function addListener(e) {
    if (e.keyCode === 9) {
        $('body').addClass('keyboard-focus');
        window.removeEventListener('keydown', addListener);
        window.addEventListener('mousedown', removeListener);
    }
}

/**
 * Adds a "keyboard-focus" event to body if the keyboard is being used to navigate
 */
function highlightFocus() {
    window.addEventListener('keydown', addListener);
}

module.exports = {
    highlightFocus: highlightFocus
};
